module.exports = __webpack_public_path__ + "static/media/default-social-sharing-image-fr.534de2f5.png";